import i18n from 'v2/helpers/i18n';

const featuresActions = [
  { id: 1, text: i18n.t('update-features') },
  { id: 2, text: i18n.t('settings') },
];
export default featuresActions;
